/**
 * Weirwood
 * Copyright 2019 Baidu Inc. All rights reserved.
 *
 * @file 浏览器头信息插件
 * @author zengxiaohui(zengxiaohui@baidu.com)
 */

import {Plugin} from './Plugin';
import {getGlobal} from '../utils/global';
import {Request} from '../interface/options.interface';

const global = getGlobal() as Window;
export class UserAgentPlugin implements Plugin {
    static id = 'UserAgent';
    name = UserAgentPlugin.id;
    client: any;

    setupOnce(client: any): void {
        this.client = client;
        this.client.captureUserAgent(this.getUserAgent());
    }

    getUserAgent(): Request {
        if ('navigator' in global && 'document' in global) {
            return {
                url: global.location.href,
                headers: {
                    'User-Agent': global.navigator.userAgent,
                    'Referrer': global.document.referrer
                }
            };
        }
        return {};
    }
}
